export const Styles = {
    button: {
        textTransform: 'uppercase',
    },
};
